import { CalendarIcon, DriverDeliveryIcon, FileIcon, RecentIcon, WorkQueueIcon } from '../IconIndex';

// eslint-disable-next-line import/prefer-default-export
export const items = [
    {
        path: '/recent',
        label: 'Recent',
        icon: RecentIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '/work-queue',
        label: 'Task Queue',
        icon: WorkQueueIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '/calendar',
        label: 'Calendar',
        icon: CalendarIcon
    },
    {
        path: '/runsheet',
        label: 'Run Sheet',
        icon: FileIcon
    },
    {
        path: '/delivery',
        label: 'Driver',
        icon: DriverDeliveryIcon
    }
];
